import React from 'react';

import { IMarketingTileBasicFragment, Maybe } from 'generated/sanity-graphql';

import MarketingTileListElement from './marketing-tile-list-element';
import { ListContainer } from './styled';

interface MarketingTileListProps {
  tiles: Maybe<ReadonlyArray<Maybe<IMarketingTileBasicFragment>>>;
}

export const MarketingTileList = ({ tiles, ...props }: MarketingTileListProps) => {
  if (!tiles?.length) {
    return null;
  }

  return (
    <ListContainer {...props}>
      {tiles.map(basicTile => {
        if (!basicTile) {
          return null;
        }
        return <MarketingTileListElement key={basicTile._id} basicTile={basicTile} />;
      })}
    </ListContainer>
  );
};
